<template>
  <h3 class="h3">Benötigst du ein Leihfahrzeug?</h3>

  <RadioMenu v-model="borrowVehicle" :options="options"/>

  <div class="flex justify-between mt-5 items-center">
    <input type="button" class="button prev" :value="Navigation.ZURÜCK" @click="prev"/>
    <input type="button" class="button next" :disabled="nextDisabled" :value="Navigation.WEITER" @click="next"/>
  </div>
  <div class="text-center">
    <span class="!text-gray-200 !text-xs !font-sans">digital begeistert von <a href="https://www.codeandcomments.at" class="!underline !text-xs !text-gray-200 !font-sans">code & comments</a></span>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { DetailStep, JaNein, Navigation } from '../../models/enums'
import { useStore } from 'vuex';
import RadioMenu from '../../components/RadioMenu.vue'
import { scrollToTop } from '@/models/helper';

const store = useStore();
const nextDisabled = computed(() => store.state.borrowVehicle == null);

const options = Object.values(JaNein);
const borrowVehicle = computed({
  get: () => store.state.borrowVehicle,
  set: value => store.commit("updateBorrowVehicle", value)
});

const prev = () => {
  store.commit("stepBack");
  scrollToTop();
}
const next = () => {
  store.commit("updateStep", DetailStep.TERMIN);
  scrollToTop();
}
</script>

<style scoped lang="scss">
h3 {
  @apply mb-3;
}
</style>
